import { classNames } from '../../utils/helpers';

const SIZES = { sm: 'w-7 h-7 text-xs', md: 'w-9 h-9 text-sm', lg: 'w-12 h-12 text-md' };

// Deterministic gradient from the name so the same person keeps the same colour.
const GRADIENTS = [
  'from-violet-500 to-indigo-600', 'from-sky-500 to-blue-600',
  'from-emerald-500 to-teal-600', 'from-amber-500 to-orange-600',
  'from-pink-500 to-rose-600',   'from-fuchsia-500 to-purple-600',
];

function initials(name: string): string {
  const parts = (name || '?').trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}

export default function Avatar({ name, size = 'md', className = '' }: {
  name: string; size?: keyof typeof SIZES; className?: string;
}) {
  const idx = (name || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0) % GRADIENTS.length;
  return (
    <div className={classNames(
      'inline-flex items-center justify-center rounded-full font-semibold text-white bg-gradient-to-br shrink-0',
      GRADIENTS[idx], SIZES[size], className,
    )}>
      {initials(name)}
    </div>
  );
}
